import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=576d6bde&scoped=true"
import script from "./Version.vue?vue&type=script&lang=ts"
export * from "./Version.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576d6bde",
  null
  
)

export default component.exports